import { Button } from '@/design-system';
import { DashboardLayout } from '@/layout/DashboardLayout';
import { DashboardKpiCards } from './components/DashboardKpiCards';
import { DashboardAnalytics } from './components/DashboardAnalytics';
import { DashboardRecentSubscriptions } from './components/DashboardRecentSubscriptions';
import { useDashboardOverview } from './hooks/useDashboardOverview';

export function DashboardPage() {
  const { stats, recentSubscriptions, isLoading, isFetching, isError, loadStats } = useDashboardOverview();
  return (
    <DashboardLayout title="Dashboard">
      <div className="space-y-6">
        {isError && (
          <div role="alert" className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
            <span>Não foi possível atualizar o dashboard.</span>
            <Button variant="subtle" size="sm" onClick={loadStats} disabled={isFetching}>Tentar novamente</Button>
          </div>
        )}
        <DashboardKpiCards stats={stats} isLoading={isLoading} />
        <DashboardAnalytics stats={stats} loading={isLoading} />
        {(!isError || stats) && (
          <DashboardRecentSubscriptions subscriptions={recentSubscriptions} isLoading={isLoading} />
        )}
      </div>
    </DashboardLayout>
  );
}
